import React, { useEffect, useState } from "react";
import modalStyles from "../styles/components/Modal.module.css";
import styles from "../styles/components/LoraPicker.module.css";
import useApi from "../hooks/useApi";

const CharacterPicker = ({onClose, onSelect, onRemove, usedCharacters}) => {

  const [characters, setCharacters] = useState([]);
  const [selected, setSelected] = useState(null);
  const {get} = useApi();
	// const dispatch = useDispatch();

  useEffect(()=>{
	
	const getLoras = async () => {
	  const response = await get(`/webapp/characters/`);
	  setCharacters(response);
	}
	getLoras();
  }, []);

  const isUsed = (c) => {
    const used = usedCharacters.filter((character) => (character.key === c.id+c.name));
    return used.length > 0;
  }

  const getCharacterStyle = (c) => {
    if(selected != null){
      return selected === c.id ? styles.loraItem : styles.loraItemUsed
    }else{
      return styles.loraItem;
    }

  }

  // console.log(usedCharacters)

  const handleSelect = (character) => {
    // console.log(character)
    setSelected(character.id);
    // if(isUsed(character)) return;
    // onSelect(character);
  }

  return (
	<div className={modalStyles.modalOverlay}>
	  <div className={modalStyles.modalContent} style={{width: "50%", height: "50%"}}>
      <div className={styles.text}>Pick a character</div>
      <div className={modalStyles.modalButtons}>
        <button onClick={onClose} className={modalStyles.cancelButton}>
          cancel
        </button>
      </div>
      <div className={styles.loraGrid}>
        {characters.map((character)=>(
          <>
            { character?.id !== selected &&
              <div key={character?.id} className={getCharacterStyle(character)} onClick={(e) => handleSelect(character)}>
                <img src={character?.thumbnail}/>
              </div>
            }
            { character?.id === selected &&
            <>
              {character?.thumbnails.map((variant, index)=> (
                <div key={`${index}_${character.id}`} className={isUsed(variant) ? styles.loraItemUsed : styles.loraItem} onClick={(e) => onSelect(variant, index)}>
                  <img src={variant}/>
                </div>
              ))}
            </>
          }
          </>
        ))}
      </div>
	  </div>
	</div>
  );
}
export default CharacterPicker;
